/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Section: Photos
 */

import { useState } from 'react';
import { Card, Carousel, Container, Modal, Row } from 'react-bootstrap'

import { MdAdd } from 'react-icons/md';

// Components
import ImageCard from './ImageCard';
import ImgNextGen from '../../../components/ImgNextGen';

// Styles
import './style.scss';

const Photos = (props) => {
    const {images,limit} = props;

    // Images
    const imagesToShow = props.hasOwnProperty("limit") ? limit : 6;
    const tempImagesArray = images.slice(0,imagesToShow); //temporary array
    const hasMore = images.length !== 0 ? images.length - imagesToShow : 0;

    // Handle Modal Visibility
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Handle Modal Opening
    const [activeIndex, setActiveIndex] = useState(0);
    const handleOnClick = index => {
        setActiveIndex(index);
        handleShow();
    };

    return (
        <div id="photos">
            <Container fluid="xxl" className="p-0">
                <Row xs={2} sm={1} md={2} lg={4} className="g-0">
                    {tempImagesArray.map((gallery, idx) => {
                        return(
                            <Card
                                key={idx}
                                className="photos__image-card" onClick={() => handleOnClick(idx)}
                            >
                                <ImageCard image={gallery} />

                                {hasMore !== 0 && idx === imagesToShow - 1 ? (
                                    <Card.ImgOverlay className="photos__overlay_content">
                                        <Card.Title className="text-center">
                                            <h2 className="mb-0"><i><MdAdd/></i>{hasMore}</h2>
                                        </Card.Title>
                                    </Card.ImgOverlay>
                                ) : null}
                            </Card>
                        );
                    })}
                </Row>
            </Container>
        
            <Modal 
                show={show}
                onHide={handleClose}
                centered
                fullscreen={"sm-down"}
                size="xl"
            >                
                <Modal.Header closeButton>
                    <Modal.Title>Galeria</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    <Carousel defaultActiveIndex={activeIndex}>
                        {images.map((image, idx) => {
                            return (
                                <Carousel.Item key={idx}>
                                    <span>{idx + 1} / {images.length}</span>
                                    
                                    <ImgNextGen
                                        srcWebp={image.srcWebp}
                                        fallback={image.src}
                                        alt={image.altText}
                                    />

                                    <Carousel.Caption>
                                        <h4>{image.header}</h4>
                                        <p>{image.caption}</p>
                                    </Carousel.Caption>
                                </Carousel.Item>
                            );
                        })}
                    </Carousel>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Photos;
